import { z } from 'zod';
import { AlphanumericLabelSchema, LocationSchema } from '../common/schemas';

/**
 * Shared & Helper Schemas
 */

/**
 * DB Schemas
 */

export const DBRoomLocationSchema = LocationSchema;
export const DBRoomRoomIdSchema = z
  .string()
  .regex(/^([1-9][0-9]*|[A-Za-z][A-Za-z0-9]*)$/)
  .min(1)
  .max(4);
export const DBRoomLabelSchema = AlphanumericLabelSchema.min(1).max(16);

export const DBRoomSchema = z.object({
  location: DBRoomLocationSchema,
  roomId: DBRoomRoomIdSchema,
  label: DBRoomLabelSchema,
});

/**
 * Client Schemas
 */

export const RoomIdSchema = z.string().brand<'RoomId'>();
export const RoomLocationSchema = DBRoomLocationSchema;
export const RoomCodeSchema = DBRoomRoomIdSchema;
export const RoomLabelSchema = DBRoomLabelSchema;

export const RoomSchema = z.object({
  id: RoomIdSchema.meta({ title: 'Room ID' }),
  location: RoomLocationSchema.meta({ title: 'Location' }),
  code: RoomCodeSchema.meta({ title: 'Room code' }),
  label: RoomLabelSchema.meta({ title: 'Label' }),
});
